import React, { Component } from 'react';
import actions from '../actions';
import sharedActions from '../../shared/actions' ;
import terminalActions from '../../terminals/actions';
import { connect } from 'react-redux';
import InterfacesForm from './../components/InterfacesForm';
import Validators from './../../shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import {interfaceHistoryConfig} from '../utils/InterfaceUtils';
import _ from '../../shared/utils/ObjectUtils';

class InterfacesFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.interfaceId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.interfaceId),
            alert: {
                show: false
            },
            interfaceFormData: {
                interfaceIdentifier: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                dataType: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                historyConfiguration: {
                    value: undefined,
                    error: undefined,
                    required: true,
                    data: []
                },
                historyMaxAge: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                unitType: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                category: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                interfaceType: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                lastCommunication: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                lastReading: {
                    value: undefined,
                    error: undefined,
                    required: false
                }
            }
        }
    }

    componentDidMount() {
        const { 
            interfaceId,
            terminalId,
            getInterfaceData, 
            getAssociatedEntitiesList, 
            getUnitTypeList, 
            getCategoryList,
            getTerminalData
        } = this.props;

        if (interfaceId) {
            getInterfaceData(interfaceId);
            getAssociatedEntitiesList(interfaceId);
        }
        if(terminalId) {
            getTerminalData(terminalId);
        }
        getUnitTypeList();
        getCategoryList();
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {

        const {
            loadingDeleteRequest : oldLoadingDeleteRequest,
            loadingCreateRequest : oldLoadingCreateRequest,
            loadingEditRequest : oldLoadingEditRequest,
            loadingInterface: oldLoadingInterface
        } = this.props;
        const {
            loadingDeleteRequest : nextLoadingDeleteRequest,
            loadingCreateRequest : nextLoadingCreateRequest,
            loadingEditRequest : nextLoadingEditRequest,
            loadingInterface: nextLoadingInterface,
            loadingTerminal: nextLoadingTerminal,
            interfaceWasDeleted,
            interfaceWasCreated,
            interfaceWasEdited,
            interfaceData,
            terminal,
            error
        } = nextProps;

        //Handle Error, Edit and Create
        if (oldLoadingDeleteRequest && !nextLoadingDeleteRequest) {
            if (interfaceWasDeleted) {
                this.handleInterfaceDeleteSuccess()
            } else {
                this.handleInterfaceDeleteError(error)
            }
        } else if (oldLoadingCreateRequest && !nextLoadingCreateRequest){
            if (interfaceWasCreated) {
                this.handleInterfaceCreateSuccess()
            } else {
                this.handleInterfaceCreateError(error)
            }
        } else if (oldLoadingEditRequest && !nextLoadingEditRequest){
            if (interfaceWasEdited) {
                this.handleInterfaceEditSuccess()
            } else {
                this.handleInterfaceEditError(nextProps.error)
            }
        } else if (oldLoadingInterface && !nextLoadingInterface) {
            this.handleInterfaceLoadingCompleted(interfaceData);
        }
        if(!nextLoadingInterface && !nextLoadingTerminal && terminal && interfaceData) {
            this.handleTerminalAndInterfaceLoadingCompleted(terminal, interfaceData);
        }
    };

    handleInterfaceLoadingCompleted = interfaceData => {
        this.setState({
            interfaceFormData: {
                ...this.state.interfaceFormData,
                ...Object.entries(interfaceData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.interfaceFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    }

    handleTerminalAndInterfaceLoadingCompleted = (terminal, interfaceData) => {
        const { 
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        const interfaceTitle = interfaceData.name ? interfaceData.name : I18n.t('routes.interfacesCreate');

        updateCustomTitle(terminal.name + " | " + interfaceTitle);
        updateCustomBreadcrumbs([{
            link: "/terminals",
            name: I18n.t('routes.terminals')
        }, {
            link: "/terminals/" + terminal.id,
            name: terminal.name
        }, {
            link: "/terminals/" + terminal.id + "/interfaces/" + interfaceData.id,
            name: interfaceTitle
        }]);
    }

    handleFieldChange = (id, value) => {
        this.setState({
            interfaceFormData: {
                ...this.state.interfaceFormData,
                [id]: {
                    ...this.state.interfaceFormData[id],
                    value: value
                }
            }
        }, () => {
            if(_.has(this.state.interfaceFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { interfaceFormData } = this.state;
        let error = null;
        switch (key) {
            case "historyMaxAge":
                error = error = !Validators.isInteger(interfaceFormData[key].value) && interfaceFormData.historyConfiguration.value !== interfaceHistoryConfig.NO_HISTORY? I18n.t('interfaces.errors.invalidHistoryMaxAge') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(interfaceFormData[key].error) &&
                    interfaceFormData[key].required &&
                    !_.isNilOrEmpty(interfaceFormData[key].value) ) {
                    error = undefined;
                } else if(interfaceFormData[key].required &&
                    _.isNilOrEmpty(interfaceFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== interfaceFormData[key].error) {
            interfaceFormData[key].error = error;
            this.setState({
                interfaceFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, interfaceFormData } = this.state;
        const { interfaceId, editInterface, createInterface } = this.props;
        let formHasErrors = false;

        _.forOwn(interfaceFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value)) && (interfaceFormData.historyConfiguration.value !== interfaceHistoryConfig.NO_HISTORY && interfaceFormData.historyMaxAge.value === null)) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        });

        if(!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(interfaceFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, { })

            const { terminalId } = this.props;

            formDataToBeSubmitted.terminalId = terminalId;

            const interfaceIdentifier = formDataToBeSubmitted.interfaceIdentifier;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('interfaces.alerts.edit.title'),
                        html: I18n.t('interfaces.alerts.edit.text', {interface: interfaceIdentifier}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editInterface(interfaceId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('interfaces.alerts.create.title'),
                        html: I18n.t('interfaces.alerts.create.text', {interface: interfaceIdentifier}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createInterface(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                interfaceFormData,
            });
        }
    };

    handleEditClick =() => {
        const { editMode } = this.state;
        const { interfaceData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                interfaceFormData:
                    Object.entries(this.state.interfaceFormData).reduce((acc, keyValuePair) => {
                        return {
                            ...acc,
                            [keyValuePair[0]]: {
                                ...this.state.interfaceFormData[keyValuePair[0]],
                                value: interfaceData[keyValuePair[0]] ? interfaceData[keyValuePair[0]] : undefined,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    }

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    }

    handleBackClick = () => {
        this.props.resetInterfaceForm();
        this.hideAlert();

        const { terminalId } = this.props;
        this.props.history.push('/terminals/' + terminalId);
    }

    handleDeleteClick = () => {
        const { interfaceId, deleteInterface } = this.props;
        const {
            interfaceFormData: {
                interfaceIdentifier: {
                    value: interfaceIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('interfaces.alerts.delete.title'),
                html: I18n.t('interfaces.alerts.delete.text', {interface: interfaceIdentifier}),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteInterface(interfaceId)
                }
            }
        })
    }

    handleInterfaceDeleteSuccess = () => {
        const {
            interfaceFormData: {
                interfaceIdentifier: {
                    value: interfaceIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('interfaces.alerts.delete.success.title'),
                html: I18n.t('interfaces.alerts.delete.success.text', {interface: interfaceIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleInterfaceDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('interfaces.alerts.delete.error.title'),
                html: I18n.t('interfaces.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleInterfaceCreateSuccess = () => {
        const {
            interfaceFormData: {
                interfaceIdentifier: {
                    value: interfaceIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('interfaces.alerts.create.success.title'),
                html: I18n.t('interfaces.alerts.create.success.text', {interface: interfaceIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleInterfaceCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('interfaces.alerts.create.error.title'),
                html: I18n.t('interfaces.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleInterfaceEditSuccess = () => {
        const {
            interfaceFormData: {
                interfaceIdentifier: {
                    value: interfaceIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('interfaces.alerts.edit.success.title'),
                html: I18n.t('interfaces.alerts.edit.success.text', {interface: interfaceIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleInterfaceEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('interfaces.alerts.edit.error.title'),
                html: I18n.t('interfaces.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleAddButtonClicked = () => {
        const { terminalId, interfaceId } = this.props;
        this.props.history.push('/terminals/' + terminalId + '/interfaces/'+ interfaceId + '/entityInterfaces/create');
    };

    render() {
        const { 
            createMode, 
            editMode, 
            viewMode, 
            interfaceFormData, 
            alert 
        } = this.state;

        const { 
            loadingDeleteRequest, 
            loadingCreateRequest, 
            loadingEditRequest, 
            unitTypeList, 
            associatedEntitiesList, 
            categoryList 
        } = this.props;

        return <InterfacesForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            interfaceFormData={interfaceFormData}

            unitTypeList={unitTypeList}
            associatedEntitiesList={associatedEntitiesList}
            categoryList={categoryList}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}

            handleAddButtonClicked={this.handleAddButtonClicked}
        />
    }
}

const mapStateToProps = ({
    terminalsReducer,
    interfacesReducer 
}) => {
    return {
        interfaceData: interfacesReducer.interfaceData,
        loadingInterface: interfacesReducer.loading,
        error: interfacesReducer.error,

        loadingDeleteRequest: interfacesReducer.loadingDeleteRequest,
        interfaceWasDeleted: interfacesReducer.interfaceWasDeleted,

        loadingCreateRequest: interfacesReducer.loadingCreateRequest,
        interfaceWasCreated: interfacesReducer.interfaceWasCreated,

        loadingEditRequest: interfacesReducer.loadingEditRequest,
        interfaceWasEdited: interfacesReducer.interfaceWasEdited,

        unitTypeList: interfacesReducer.unitTypeList,
        associatedEntitiesList: interfacesReducer.associatedEntitiesList,
        categoryList: interfacesReducer.categoryList,

        terminal: terminalsReducer.terminalData,
        loadingTerminal: terminalsReducer.loadingTerminal
    };
};

const mapDispatchToProps = {
    getInterfaceData: actions.getInterfaceData,
    createInterface: actions.createInterface,
    editInterface: actions.editInterface,
    deleteInterface: actions.deleteInterface,
    resetInterfaceForm: actions.resetInterfaceForm,
    getUnitTypeList: actions.getUnitTypeList,
    getAssociatedEntitiesList: actions.getAssociatedEntitiesList,
    getCategoryList: actions.getCategoryList,

    getTerminalData: terminalActions.getTerminalData,
    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InterfacesFormContainer);
